'use strict';

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (darc) {
  darc.addOperation({
    name: 'top',
    args: [],
    description: '',
    inputs: 'T[]',
    outputs: 'T',
    global: true,
    resolve: function resolve(msg, elements) {
      var output = {};
      var i = 0;

      var unroll = function unroll(item) {
        if ((0, _isArray2.default)(item)) {
          (0, _map2.default)(item, unroll);
        } else {
          output['$' + i] = item;
          i++;
        }
      };

      (0, _map2.default)(elements, unroll);
      return output;
    },
    update: function update(msg) {
      throw "NotImplemented"; // var deltas = {};
      // _.each( msg.deltas, ( value, key ) => {
      //
      // 	deltas[ key.substring( 1 ) ] = value;
      //
      // } );
      //
      // msg.deltas = {
      // 	$0: deltas
      // };
    }
  });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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